import React from "react";
import PropTypes from "prop-types";

const classNames = require("classnames");

const ProgressBarHeaderListItem = ({ step, i, currentIndex }) => {
  return (
    <li className={classNames("step", 'text-center')}>
      <small
        className={classNames(step.className, {
          active: i === currentIndex
        })}
      >
        {step.value}
      </small>
      {step.subheader ? (
        <div
          className={classNames(step.subheader.className, {
            active: i === currentIndex
          })}
        >
          {step.subheader.value}
        </div>
      ) : null}
    </li>
  );
};

const ProgressBarHeader = ({ steps, currentIndex, className }) => {
  return (
    <ul className={classNames("progress-bar-header", className)}>
      {steps.map((step, i) => {
        return (
          <ProgressBarHeaderListItem
            key={step.value}
            step={step}
            i={i}
            currentIndex={currentIndex}
          />
        );
      })}
    </ul>
  );
};

ProgressBarHeader.defaultProps = {
  steps: [],
  className: ""
};

ProgressBarHeader.propTypes = {
  steps: PropTypes.arrayOf(
    PropTypes.shape({}),
    PropTypes.string,
    PropTypes.number
  )
};

export default ProgressBarHeader;
